import { Component, OnInit, style } from "@angular/core";
import { AuthService } from "../../services/auth.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { Router, ActivatedRoute } from "@angular/router";
import { ValidateService } from "../../services/validate.service";
import { HostListener } from "@angular/core";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.css"],
})
export class ProfileComponent implements OnInit {
  user: Object;

  prenom: String;
  nom: String;
  email: String;
  centre: String;
  profession: String = "";
  password: String;
  communication: Boolean = true;
  screenHeight: any;
  screenWidth: any;
  token: String;
  constructor(
    private validateService: ValidateService,
    private flashMessagesService: FlashMessagesService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.getScreenSize();
  }
  //modal style

  //end

  @HostListener("window:resize", ["$event"])
  getScreenSize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    console.log(this.screenHeight, this.screenWidth);
  }

  //confirmation pour PC
  tempAlert(msg, duration) {
    var el = document.createElement("div");
    el.setAttribute(
      "style",
      "position:fixed;left:25%;bottom:50%;width:50%;height:200px;background-color:#fefefe;border: 1px solid #009dda; border-radius: 8px;text-align:centre,color:red; font-family: 'MS Serif', 'New York', sans-serif; "
    );
    el.innerHTML = msg;
    setTimeout(function () {
      el.parentNode.removeChild(el);
    }, duration);
    document.body.appendChild(el);
  }

  //confirmation pour Mobile
  tempAlertMobile(msg, duration) {
    var le = document.createElement("div");
    le.setAttribute(
      "style",
      "position:fixed;left:11%;bottom:50%;width:80%;height:200px;background-color:#fefefe;border: 1px solid #009dda; border-radius: 8px;text-align:centre;font-family: Arial"
    );
    le.innerHTML = msg;
    setTimeout(function () {
      le.parentNode.removeChild(le);
    }, duration);
    document.body.appendChild(le);
  }

  ngOnInit() {
    //this.tempAlert("<Sytong> <center></br>Super, votre inscription à la web-émission a bien été pris en compte et vous allez recevoir un email de confirmation. </br></br>  Rendez-vous le 14 mars à 19h00.</center></Sytong>",15000);
    //alert("Vos infos ont été bien enregistré dans nos serveur");

    //this.tempAlertMobile("<Sytong> <center></br>Super, votre inscription à la web-émission a bien été pris en compte et vous allez recevoir un email de confirmation. </br></br>  Rendez-vous le 14 mars à 19h00.</center></Sytong>",15000);

    this.user = this.authService.user;
    this.route.queryParams.subscribe(params => {
      let token = params['token']

      if (token) {
        this.token = token;
        this.OnTokenValidate();
      }
    })
  }

  onSuscribeSubmit() {
    console.log(this.communication)
    const user = {
      prenom: this.prenom,
      nom: this.nom,
      email: this.email,
      centre: this.centre,
      profession: this.profession,
      password: "naGLLgDY8sgLba2a", //Math.random().toString(36).substr(2, length)
    };

    if (!this.validateService.validateSuscribe(user)) {
      this.flashMessagesService.show("svp veuillez verifier tous les champs", {
        cssClass: "alert-danger",
        timeout: 3000,
      });
      return false;
    }
    if (!this.validateService.validEmail(user.email)) {
      this.flashMessagesService.show("svp veuillez utiliser un email valide", {
        cssClass: "alert-info",
        timeout: 3000,
      });
      return false;
    }

    console.log("send")
    // suscribe user
    this.authService.suscribeUser(user).subscribe((data) => {
      console.log("sended")
      if (data.success) {
        console.log("suucèss")

      } else {
        this.flashMessagesService.show(
          "Linscription na pas reussie veuillez reessayer plus tard ",
          { cssClass: "alert-danger", timeout: 3000 }
        );
        this.router.navigate(["/"]);
      }

      //setTimeout(function(){ alert("Vos infos ont été bien enregistré dans nos serveur"); }, 1000);


    });
    document.getElementById("modal-wrapper").style.display = "none";
    if (this.screenWidth < 800) {
      this.tempAlertMobile(
        "<Sytong> <center></br><div style='margin: 0;position: absolute;top: 50%;-ms-transform: translateY(-50%);transform: translateY(-50%);'>Merci, votre inscription au webinar Rôle des Urgences dans la prévention et la lutte contre le VIH & les Hépatites virales a bien été prise en compte et vous allez recevoir un email de confirmation. Si vous ne recevez pas l'email de confirmation, veuillez vérifier dans votre boîte SPAM ou attendez quelques minutes. A bientôt !</div></br></center></Sytong>",
        15000
      );
      console.log("hello from inferieur À 800");
    } else {
      console.log("hello from superieur a 800");

      this.tempAlert(
        "<Sytong> <center></br><div style='margin: 0;position: absolute;top: 50%;-ms-transform: translateY(-50%);transform: translateY(-50%);'>Merci, votre inscription au webinar Rôle des Urgences dans la prévention et la lutte contre le VIH & les Hépatites virales a bien été prise en compte et vous allez recevoir un email de confirmation. Si vous ne recevez pas l'email de confirmation, veuillez vérifier dans votre boîte SPAM ou attendez quelques minutes. A bientôt !</div></br></center></Sytong>",
        15000
      );
    }
    setTimeout(function () {
      document.getElementById("modal-wrapper").style.display = "initial";
    }, 15000);
    this.router.navigate(["/"]);
  }

  OnTokenValidate() {
    document.getElementById("modal-wrapper").style.display = "none";
    var le = document.createElement("div");
    if (this.screenWidth < 800) {
      le.setAttribute(
        "style",
        "position:fixed;left:11%;bottom:50%;width:80%;height:200px;background-color:#fefefe;border: 1px solid #009dda; border-radius: 8px;text-align:centre;font-family: Arial"
      );
    } else {
      le.setAttribute(
        "style",
        "position:fixed;left:25%;bottom:50%;width:50%;height:200px;background-color:#fefefe;border: 1px solid #009dda; border-radius: 8px;text-align:centre,color:red; font-family: 'MS Serif', 'New York', sans-serif; "
      );
    }
    le.innerHTML = "<Sytong> <center></br><div style='margin: 0;position: absolute;top: 50%;-ms-transform: translateY(-50%);transform: translateY(-50%);'>Votre inscription au webinar Rôle des Urgences dans la prévention et la lutte contre le VIH & les Hépatites virales est en cours de validation, merci de patienter...</div></br></center></Sytong>";
    this.authService.validateUser(this.token).subscribe((data) => {
      console.log(data.status)
      if (data) {
        le.innerHTML = "<Sytong> <center></br><div style='margin: 0;position: absolute;top: 50%;-ms-transform: translateY(-50%);transform: translateY(-50%);'>Merci, votre inscription au webinar Rôle des Urgences dans la prévention et la lutte contre le VIH & les Hépatites virales a bien été validée et vous allez recevoir un email de confirmation. Si vous ne recevez pas l'email de confirmation, veuillez vérifier dans votre boîte SPAM ou attendez quelques minutes. A bientôt !</div></br></center></Sytong>";
      }
    })
    document.body.appendChild(le);
  }

  /*

<div class="container" *ngIf="user">
	    <h2> Profile Utilisateur </h2> 
 <h3 class="page-header"> {{user.login}}</h3>    
    
    <table class="table">
  <thead class="thead-inverse">
    <tr>
      
      <th>Email(login)</th>
      <th>ville</th>
      
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>{{user.login}}</td>
      <td>{{user.ville}}</td> 
    </tr>
  </tbody>
</table>
</div>
*/
}



// WEBPACK FOOTER //
// ./src/app/components/profile/profile.component.ts